import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GameDetail from "../pages/game/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/game/:slug",
    element: <GameDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
